import React from "react";
import "./LibraryMembers.css";

import Member1 from "../images/member1.jpg";
import Member2 from "../images/member2.jpg";
import Member3 from "../images/member3.jpg";
import Member4 from "../images/member4.jpg";

const LibraryMembers = () => {
  return (
    <section className="library-members-section">
      <h2 className="library-members-heading">
        “आमचे मार्गदर्शक व कार्यकारिणी”
      </h2>

      <div className="library-members-container">

        <div className="library-member-card">
          <img src={Member1} alt="Member" />
          <h4>आमचे प्रेरणास्थान</h4>
          <p>कै. रघुनाथ रामचंद्र बुरांडे गुरुजी</p>
        </div>

        <div className="library-member-card president">
          <img src={Member2} alt="President" />
          <h4>ग्रंथालय अध्यक्ष</h4>
          <p>श्री. मकरंद जगन्नाथ बुरांडे</p>
        </div>

        <div className="library-member-card">
          <img src={Member3} alt="Member" />
          <h4>सचिव</h4>
          <p>श्री. महादेव भीमराव पाटील</p>
        </div>

        <div className="library-member-card">
          <img src={Member4} alt="Member" />
          <h4>खजिनदार</h4>
          <p>श्री.ओंकार मकरंद बुरांडे</p>
        </div>

      </div>
    </section>
  );
};

export default LibraryMembers;
